import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

/**
 * Delegated add-to-cart for cart drawer upsell rows (survives section morph).
 * Mirrors product-variant-drawer: quantity rules, Stock Message + _pre-order line properties.
 */
function collectSectionIds() {
  /** @type {string[]} */
  const ids = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    const id = /** @type {HTMLElement} */ (el).dataset.sectionId;
    if (id) ids.push(id);
  });
  return ids;
}

document.body.addEventListener('click', async (event) => {
  const target = /** @type {HTMLElement | null} */ (event.target);
  const button = /** @type {HTMLButtonElement | null} */ (target?.closest('[data-cart-upsell-add]'));
  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const quantity = Math.max(1, parseInt(button.dataset.quantity || '1', 10) || 1);

  const item = button.closest('.cart-drawer-upsells__item');
  const errEl = item?.querySelector('.cart-drawer-upsells__error');
  if (errEl) {
    errEl.textContent = '';
    errEl.classList.add('hidden');
  }

  event.preventDefault();
  button.disabled = true;

  const formData = new FormData();
  formData.append('form_type', 'product');
  formData.append('utf8', '✓');
  formData.append('id', variantId);
  formData.append('quantity', String(quantity));

  const stockMessage = button.dataset.stockMessage?.trim();
  if (stockMessage) {
    formData.append('properties[Stock Message]', stockMessage);
  }
  if (button.dataset.preorder === 'true') {
    formData.append('properties[_pre-order]', 'true');
  }

  const sectionIds = collectSectionIds();
  if (sectionIds.length) {
    formData.append('sections', sectionIds.join(','));
  }

  const fetchCfg = fetchConfig('javascript', { body: formData });

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    });
    const data = await response.json();

    if (data.status) {
      const msg =
        (typeof data.description === 'string' && data.description) ||
        (typeof data.message === 'string' && data.message) ||
        '';
      if (errEl && msg) {
        errEl.textContent = msg;
        errEl.classList.remove('hidden');
      }
      document.dispatchEvent(
        new CartAddEvent({}, 'cart-upsell-add', {
          didError: true,
          source: 'cart-upsell-add',
        })
      );
      return;
    }

    document.dispatchEvent(
      new CartAddEvent({}, variantId, {
        source: 'cart-upsell-add',
        itemCount: quantity,
        sections: data.sections,
      })
    );
  } catch (e) {
    console.error(e);
  } finally {
    button.disabled = false;
  }
});
